export default __webpack_public_path__ + "static/media/willCostsBeCovered_sm_woman.e4ccbd5a.png";